import { client } from '../../../../../App';
import { GET_AUTOMATED_COLUMNS } from '../../../../../queries/widgets';
import { normalizeAutomatedColumnsInput } from '../../../../../utils/normalizeAutomatedColumnsInput';
import { collectSquadRiskDynamicCells, normalizePerformanceRiskTable } from './performanceRiskTable';
import { formatSquadUntil } from './squadSrriwert';

/**
 * Fetch the dynamic cells of the Wertentwicklung/Risikokennzahlen table for the fund ISIN
 * as of the factsheet date. Returns raw values keyed by `squadRiskCellKey(row, col)`;
 * formatting happens in resolvePerformanceRiskTable.
 */
export async function fetchSquadPerformanceRiskValues(
  rawTable: unknown,
  isin: string,
  until?: string | null,
): Promise<Map<string, string>> {
  const out = new Map<string, string>();
  const fundIsin = String(isin || '').trim().toUpperCase();
  if (!fundIsin) return out;
  const entries = collectSquadRiskDynamicCells(normalizePerformanceRiskTable(rawTable));
  if (!entries.length) return out;

  try {
    const res = await client.query({
      query: GET_AUTOMATED_COLUMNS,
      variables: {
        param: {
          data: normalizeAutomatedColumnsInput([entries.map((e) => e.cell)]),
          isin: fundIsin,
          until: formatSquadUntil(until) || undefined,
        },
      },
      fetchPolicy: 'network-only',
    });
    const row = res?.data?.getAutomatedColumns?.[0];
    if (!Array.isArray(row)) return out;
    entries.forEach((entry, i) => {
      const val = row[i];
      if (val != null && String(val).trim() !== '') out.set(entry.key, String(val).trim());
    });
  } catch {
    // cells stay empty; the PDF dialog lists the table as missing
  }
  return out;
}
